import React, { Component } from 'react';

class ErrorMessage extends Component {
  render() {
    return <p>Данные не были загружены</p>
  }
}

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/index.js